import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export const Progressbar = ({
  value,
  height,
  width,
  isWithText = false,
  className,
}) => {
  return (
    <div style={{ width, height }} className="d-flex">
      <CircularProgressbar
        className={className}
        value={value}
        text={isWithText ? `${value}%` : ""}
        strokeWidth={14}
        styles={buildStyles({
          // Rotation of path and trail, in number of turns (0-1)
          rotation: 0.25,

          // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
          strokeLinecap: "butt",

          // Text size
          textSize: "18px",

          // How long animation takes to go from one percentage to another, in seconds
          pathTransitionDuration: 0.5,

          // Can specify path transition in more detail, or remove it entirely
          // pathTransition: 'none',

          // Colors
          // pathColor: `rgba(62, 152, 199, ${value / 100})`,
          textColor: "#000A3D",
          trailColor: "#E0E0E0",
          backgroundColor: "#018AC5",
        })}
      />
    </div>
  );
};
